import { render } from "./AllHospitals.vue?vue&type=template&id=3f06be44&scoped=true"
import script from "./AllHospitals.vue?vue&type=script&lang=js"
export * from "./AllHospitals.vue?vue&type=script&lang=js"

import "./AllHospitals.vue?vue&type=style&index=0&id=3f06be44&lang=scss&scoped=true"
import "./AllHospitals.vue?vue&type=style&index=1&id=3f06be44&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f06be44"],['__file',"src/components/hospitals/AllHospitals.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f06be44"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f06be44', __exports__)) {
    console.log('reload')
    api.reload('3f06be44', __exports__)
  }
  
  module.hot.accept("./AllHospitals.vue?vue&type=template&id=3f06be44&scoped=true", () => {
    console.log('re-render')
    api.rerender('3f06be44', render)
  })

}


export default __exports__